import { Transaction } from '@mysten/sui/transactions';
const SUI_CLOCK_OBJECT_ID = '0x6';
/** Build PTB to claim currently unlocked DGC from a linear vesting Wallet. */
export function buildClaimVestedToBalance(params) {
    const pkg = params.packageId.trim();
    if (!pkg || /^0x0+$/i.test(pkg.replace(/^0x/i, '0x'))) {
        throw new Error('vesting package id 无效');
    }
    const walletId = params.walletId.trim();
    if (!walletId)
        throw new Error('缺少 Wallet 对象 ID');
    const module = params.module ?? 'cpc_setup';
    const functionName = params.functionName ?? 'claim_vested_to_balance';
    const tx = new Transaction();
    tx.moveCall({
        target: `${pkg}::${module}::${functionName}`,
        arguments: [tx.object(walletId), tx.object(SUI_CLOCK_OBJECT_ID)],
    });
    return tx;
}
/** Client-side mirror of `vesting::linear::claimable`. */
export function computeLinearClaimableMist(params) {
    const remaining = BigInt(params.remainingMist);
    const claimed = BigInt(params.claimedMist);
    const now = params.nowMs ?? Date.now();
    if (now < params.startMs)
        return 0n;
    if (params.durationMs <= 0 || now >= params.startMs + params.durationMs) {
        return remaining;
    }
    const total = remaining + claimed;
    const elapsed = BigInt(now - params.startMs);
    const duration = BigInt(params.durationMs);
    const unlocked = (total * elapsed) / duration;
    return unlocked > claimed ? unlocked - claimed : 0n;
}
